module.exports = __webpack_public_path__ + "img/icon-sm.5e26709e.svg";